export const Footer = () => (
  <footer data-testid="footer-section" className="relative border-t border-white/10 py-12">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6">
        <div>
          <p className="font-heading text-xl font-bold text-white">
            AX <span className="text-rose-500">ACADEMY</span>
          </p>
          <p className="text-sm text-zinc-500 mt-1">A Aradhya Xenova Initiative</p>
        </div>
        <div className="flex gap-6 text-sm text-zinc-400">
          <a href="https://academy.aradhyaxenova.com" target="_blank" rel="noopener noreferrer" className="hover:text-rose-400" data-testid="footer-link-academy">
            academy.aradhyaxenova.com
          </a>
        </div>
      </div>
      <div className="mt-8 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-4 text-xs text-zinc-500">
        <p data-testid="footer-18-plus-disclaimer">🔞 All content is strictly for consenting adults aged 18 and above. Educational & science-informed content only.</p>
        <p>© {new Date().getFullYear()} AX Academy. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
